import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import { Accordion, AccordionTab } from 'primereact/accordion';
import { Button } from 'primereact/button';
import { withAccount } from '../../../../components/AccountContext';
import NewSurveyRespondentCard from './NewSurveyRespondentCard';
import ArrayUtil from '../../../../utils/ArrayUtil';
import { AsyncSelector } from '../../../../components/selector/AsyncSelector';
import { intlShape, growlShape } from '../../../../components/prop-types';
import { searchRespondents } from '../../../../services/apps/RespondentServices';
import { withGrowl } from '../../../../components/GrowlNotifications';
import { growlErrors } from '../../../../utils/NotificationUtil';
import AddRespondentForm from './AddRespondentFormContainer';

const surveyGroupTypeMessages = defineMessages({
  managers: { id: '360.managers', defaultMessage: 'Bosses' },
  peers: { id: '360.peers', defaultMessage: 'Peers' },
  directReports: { id: '360.directReports', defaultMessage: 'Direct Reports' },
  others: { id: '360.others', defaultMessage: 'Others' },
});

const messages = defineMessages({
  addRespondent: {
    id: 'candidate.add',
    defaultMessage: 'Add Respondent',
  },
});

class NewSurveySubRespondents extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeIndex: [0],
      respondents: [],
      loadingRes: false,
      isAddingFormShown: false,
    };
    this.searchRespondent = this.searchRespondent.bind(this);
    this.tabChange = this.tabChange.bind(this);
    this.showAddingForm = this.showAddingForm.bind(this);
  }

  componentDidMount() {
    this.fetchRespondents();
  }

  searchRespondent(query) {
    this.fetchRespondents(query);
  }

  async fetchRespondents(query) {
    const { currentAccount, growl } = this.props;
    this.setState({ loadingRes: true });
    try {
      const respondents = await searchRespondents({
        aid: currentAccount,
        query,
      });

      this.setState({
        respondents,
        loadingRes: false,
      });
    } catch (errors) {
      growlErrors(growl, errors);
      this.setState({ loadingRes: false });
    }
  }

  tabChange(event) {
    const { index } = event;
    this.setState({ activeIndex: index });
  }

  showAddingForm(isAddingFormShown) {
    this.setState({
      isAddingFormShown,
    });
  }

  render() {
    const {
      type,
      selectedRespondents,
      subRespondents,
      intl: { formatMessage },
    } = this.props;
    const {
      onRemove, onAdd,
    } = this.props;
    const sortedSubRespondents = ArrayUtil.sortSurveyRespondentAlphabet(subRespondents);

    const groupName = formatMessage(surveyGroupTypeMessages[type]);
    const addRespondentLabel = formatMessage(messages.addRespondent);
    const {
      activeIndex, loadingRes, respondents,
      isAddingFormShown,
    } = this.state;
    return (
      <div className="accordion-legacy-container">
        <Accordion
          multiple
          activeIndex={activeIndex}
          onTabChange={this.tabChange}
        >
          <AccordionTab header={groupName}>
            {ArrayUtil.isEmpty(sortedSubRespondents) && (
              <FormattedMessage id="candidate.empty" defaultMessage="Empty" />
            )}

            {sortedSubRespondents.map(r => (
              <NewSurveyRespondentCard
                {...this.props}
                key={r.respondent.id}
                onRemove={id => onRemove(id, type)}
                type={type}
                assessment={r}
              />
            ))}
            <div className="p-grid">
              <div className="p-col-12 field-label field-label--small t-small">
                <p>
                  <FormattedMessage id="actions.add" defaultMessage="Add" />
                  {` ${groupName}`}
                </p>
              </div>

              <div className="p-col-12">
                <FormattedMessage id="placeholder.autocomplete.name" defaultMessage="Start typing a name">
                  {text => (
                    <AsyncSelector
                      placeholder={text}
                      filter="contains"
                      value={null}
                      dataSearch={this.searchRespondent}
                      onChange={value => onAdd(value, type)}
                      data={respondents}
                      processing={loadingRes}
                      selectedList={selectedRespondents}
                      valueField="id"
                      textField={item => (item ? `${item.firstName} ${item.lastName}` : '')}
                    />
                  )}
                </FormattedMessage>
              </div>
            </div>
            <div>
              {
                isAddingFormShown
                  ? (
                    <AddRespondentForm
                      type={type}
                      onAdd={onAdd}
                      toggleEdit={this.showAddingForm}
                    />
                  )
                  : (
                    <Button
                      type="button"
                      icon="pi pi-plus"
                      label={addRespondentLabel}
                      onClick={() => {
                        this.showAddingForm(true);
                      }}
                    />
                  )
              }
            </div>
          </AccordionTab>
        </Accordion>
      </div>
    );
  }
}

NewSurveySubRespondents.propTypes = {
  selectedRespondents: PropTypes.arrayOf(PropTypes.any).isRequired,
  subRespondents: PropTypes.arrayOf(PropTypes.any).isRequired,
  intl: intlShape.isRequired,
  onRemove: PropTypes.func.isRequired,
  onAdd: PropTypes.func.isRequired,
  currentAccount: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  growl: growlShape.isRequired,
};

export default withGrowl(
  withAccount(injectIntl(NewSurveySubRespondents)),
);
